"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
var ScaleInOutChild_1 = require("./ScaleInOutChild");
var ScaleInOut = /** @class */ (function (_super) {
    __extends(ScaleInOut, _super);
    function ScaleInOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScaleInOut.prototype.render = function () {
        var _a = this.props, appearAnimate = _a.appearAnimate, childAttributes = _a.childAttributes, children = _a.children, enterDelay = _a.enterDelay, leaveDelay = _a.leaveDelay, maxScale = _a.maxScale, minScale = _a.minScale, mode = _a.mode, speed = _a.speed, style = _a.style, others = __rest(_a, ["appearAnimate", "childAttributes", "children", "enterDelay", "leaveDelay", "maxScale", "minScale", "mode", "speed", "style"]);
        var styles = getStyles(this);
        return (React.createElement(react_transition_group_1.TransitionGroup, __assign({}, others, { style: styles.root, component: "div" }), React.Children.map(children, function (child, index) { return (React.createElement(ScaleInOutChild_1.default, __assign({ key: child.key, minScale: minScale, maxScale: maxScale, enterDelay: enterDelay, leaveDelay: leaveDelay, mode: mode, speed: speed, appearAnimate: appearAnimate }, childAttributes), child)); })));
    };
    ScaleInOut.defaultProps = {
        appearAnimate: true,
        children: React.createElement("div", null, "ScaleInOut"),
        enterDelay: 0,
        leaveDelay: 0,
        maxScale: 1,
        minScale: 0,
        mode: "both",
        speed: 500
    };
    return ScaleInOut;
}(React.Component));
exports.default = ScaleInOut;
function getStyles(ScaleInOut) {
    var _a = ScaleInOut.props, style = _a.style, speed = _a.speed;
    return {
        root: __assign({ position: "relative", overflow: "inherit", transition: "transform " + speed + "ms 0s ease-in-out" }, style)
    };
}
//# sourceMappingURL=ScaleInOut.js.map